import { Routes } from '@angular/router';

import { routeData } from '@frontend/vanilla/core';

import { ContactComponent } from './contact.component';
import { ContactResolver } from './contact.resolver';
import { contactGuard } from './parts/contact.guard';

export const contactRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                component: ContactComponent,
                canActivate: [contactGuard],
                resolve: {
                    initData: ContactResolver,
                },
            },
            {
                path: ':category',
                component: ContactComponent,
                canActivate: [contactGuard],
                resolve: {
                    initData: ContactResolver,
                },
            },
            {
                path: ':category/:subcategory',
                component: ContactComponent,
                canActivate: [contactGuard],
                resolve: {
                    initData: ContactResolver,
                },
            },
        ],
        data: routeData({ allowAllWorkflowTypes: true, allowAnonymous: true }),
    },
];
